{
  "en": {
    "salesWizard": {
      "steps": {
        "contact": "Contact Information",
        "license": "License Selection",
        "workshops": "Workshops",
        "school": "School"
      },
      "contactStep": {
        "headline": "Contact form for schools",
        "description": "Please enter your contact details so we can send you all the necessary information. Pay special attention to the correct spelling of your email address.",
        "formOfAddress": "Salutation",
        "formOfAddressFemale": "Ms.",
        "formOfAddressMale": "Mr.",
        "firstname": "First name",
        "lastname": "Last name",
        "email": "Email address",
        "phone": "Phone"
      },
      "entry": {
        "loading": "The contact form is being prepared…",
        "error": "The contact form could not be launched. Please reload the page or try again later."
      },
      "confirmation": {
        "headline": "Thank you for your inquiry!",
        "offerSingle": "You will receive an offer shortly at the following email address:",
        "offerMultiple": "You will receive various offers shortly at the following email address:",
        "support": "If you have any questions in the meantime, please contact our support at",
        "notFound": "This request was not found. Please check the link or start a new request."
      },
      "saveError": "Save failed. Please try again.",
      "choiceStep": {
        "headline": "Select one or more license options now",
        "description": "You will receive an offer for each license package, allowing you to compare them.",
        "numOfEmployees": "Size of the faculty",
        "maxMembersCount": "Number of licenses needed",
        "package": "Choose your suitable license package",
        "packageLabels": {
          "package_s": "S-License",
          "package_m": "M-License",
          "package_l": "L-License",
          "package_xl": "XL-License"
        },
        "upto": "Up to",
        "people": "people",
        "aboveLimit": {
          "headline": "Custom offer for more than 120 people",
          "description": "For offers with over 120 licenses, we are happy to advise you personally. Please call us at",
          "or": "or",
          "chooseAppointment": "schedule a consultation appointment"
        },
        "bavaria": {
          "headline": "Important information for Bavaria regarding the media and AI budget:",
          "intro": "The following license packages can be funded according to the funding guidelines and in consultation with the Bavarian State Office for Schools:",
          "items": {
            "allInclusive": "All-Inclusive School License (100% fundable)",
            "tools": "Tools School License (100% fundable)",
            "toTeach": "To Teach School License (100% fundable)",
            "combo": "Combo School License (only partially fundable)"
          },
          "moreInfo": "Find more information and a consultation link here:"
        },
        "subHeadlineCombined": "Benefit from our combo packages",
        "subHeadlineProduct": "Or select individual products here",
        "popular": "Popular",
        "year": "Year",
        "licenceItemsEmpty": "At least one license type must be selected.",
        "configLoadError": "The license options could not be loaded.",
        "itemsLoadError": "The license packages could not be loaded."
      },
      "workshopStep": {
        "headline": "Digital workshops",
        "description": "Recommendation: An annual workshop for the staff is ideal for successful fobizz adoption and higher satisfaction.",
        "itemTypes": {
          "workshop": "Practical workshop",
          "presentation": "Keynote",
          "consulting": "Individual consultation"
        },
        "durationMinutes": "{duration} minutes",
        "details": "Workshop details",
        "configLoadError": "Workshop options could not be loaded.",
        "incompleteRequest": "The request could not be submitted because previous steps are incomplete. Please go back and complete your information."
      },
      "schoolStep": {
        "headline": "Contact form for schools",
        "description": "Select your school here:",
        "searchHint": "You can search by postal code or school name.",
        "notFoundHint": "If you cannot find your school, please check the box below and enter the details yourself.",
        "searchLabel": "School",
        "searchPlaceholder": "Search for school …",
        "searchFieldHint": "Tip: You can search by postal code or school name",
        "noResults": "No school found.",
        "initialRequest": "My school is not listed",
        "companyName": "Name of institution",
        "street": "Street and house number",
        "zipcode": "Postal code",
        "city": "City",
        "countryCode": "Country",
        "kind": "Educational institution",
        "schoolType": "School type",
        "schoolTypeCustom": "Other school type",
        "baseError": "Select a school or check \"My school is not listed\" and enter the details yourself"
      },
      "taxInfo": "All prices include {rate}% VAT (or the applicable VAT rate).",
      "retry": "Try again",
      "back": "Back"
    }
  }
}
